module.exports = __webpack_public_path__ + "static/ume03-2c078b8b48d04cc9d6b37e4d37f3ab52.png";